import { request } from '../../api'
import { useServerFetch } from '../../composables/useServerFetch'

export type RankCategorySubTab = {
  businessType: number
  name: string
  englishName?: string
}

export type RankCategoryItem = {
  code: string
  name: string
  englishName?: string
  subTabs: RankCategorySubTab[]
}

export type RankCategoriesResponse = {
  items: RankCategoryItem[]
}

export const getRankCategories = () => {
  const api = useEnvApi()
  const requestConfig = {
    baseURL: import.meta.server ? api.wikibitBffGo : api.v4,
    url: '/api/v4/bit/web/rank/categories',
    method: 'GET',
  }

  return import.meta.server
    ? useServerFetch<RankCategoriesResponse>(requestConfig)
    : request<RankCategoriesResponse>(requestConfig)
}

export type RankListParams = {
  keyCode: string
  businessType: number | string
  page: number
  pageSize: number
}

export interface RankLabel {
  labelType: number
  content: string
  borderColor: string
  backgroundColor: string
  fontColor: string
  image: string
}

export interface RankingOrder {
  content: string
  fontColor: string
}

export interface TraderRankItem {
  ultimateType: number
  isProduct: number
  priority: string
  localShortName: string
  localFullName: string
  userId: string
  languageCode: string
  traderCode: string
  logo: string
  fullName: string
  shortName: string
  score: string
  status: number
  annotation: string
  traderId: string
  color: string
  isTop200: boolean
  ico: string
  icoSquare: string
  flag: string
  countryCode: string
  registerCountry: string
  slogan: string
  isAdvance: boolean
  epc: boolean
  ultimate: string
  isAdv: boolean
  isvr: boolean
  type: number
  rankingOrder: RankingOrder
  fixed: boolean
  company: string
  business?: string
  businessOperation?: string
  cryptoReguLation?: string
  isHideRating: boolean
  isWhite: boolean
  pureLScore: string
  showName: string
  exposureDesc: string
  exposureCount: number
  isBadStatus: boolean
  hitsInfo: string
  sortedLabels: RankLabel[]
  specialtyLabels: any[]
  subScript: unknown
  ultraBgColor: string
  ultraFontColor: string
  labels: RankLabel[]
  ultimateUltraIco: string
  ultimateUltraVideo: string
  ultimateUltraVideoIco: string
  viewCount: string
  viewCountUnit: string
  alias: string
  scoreIcon: string
  assetReserve?: string
  assetReserveAmount?: string
  assetReserveMoney?: string
  reserveAmount?: string
  assetReserveValue?: string
}

export interface RankListResponse {
  traderRank: TraderRankItem[]
  desc: string
}

export const getRankList = (params: RankListParams) => {
  const api = useEnvApi()
  const requestConfig = {
    baseURL: import.meta.server ? api.wikibitBffGo : api.v4,
    url: '/api/v4/bit/brand/ranklist',
    method: 'GET',
    params,
  }

  return import.meta.server
    ? useServerFetch<RankListResponse>(requestConfig)
    : request<RankListResponse>(requestConfig)
}
